/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./global.css"
import '@fontsource-variable/inter';
import '@fontsource/gochi-hand';

const VISITS_JS_SRC = 'https://checkout.sketchwow.com/wp-content/plugins/solid_affiliate/assets/js/visits.js';

function loadSolidAffiliateVisits() {
  if (document.querySelector(`script[src="${VISITS_JS_SRC}"]`)) return;
  const s = document.createElement('script');
  s.src = VISITS_JS_SRC;
  s.async = true;
  document.body.appendChild(s);
}

window.addEventListener('load', loadSolidAffiliateVisits, { once: true });

export const onRouteUpdate = ({ location }) => {
  // Any route update logic goes here
};